import { z } from 'zod';

import { TwoFaActionWizardMethods } from '../../TwoFaActionWizard.types';
import { fieldNameOption } from './ScreenMethodSelect.constants';

export const schema = z.object({
    [fieldNameOption]: z.nativeEnum(TwoFaActionWizardMethods),
});
